module.exports = __webpack_public_path__ + "assets/56776a6e4170778a94e3a0d75d55035f.png";